import React from "react";
import { Warning } from "@phosphor-icons/react";

export default function RiskBanner({ variant = "default" }) {
  const map = {
    default: {
      text: "AI-generated analysis. Not a trading recommendation. Options trading carries substantial risk of loss.",
    },
    ai: {
      text: "AI-generated. Not investment advice. Verify independently. Do your own research.",
    },
    backtest: {
      text: "Historical backtest results. Past performance does not guarantee future returns. Not a trading recommendation.",
    },
    strategy: {
      text: "AI-generated strategy for informational purposes. Not a recommendation. Consult a licensed advisor before trading.",
    },
  };
  const cfg = map[variant] || map.default;
  return (
    <div
      data-testid={`risk-banner-${variant}`}
      className="flex items-start gap-2 px-3 py-2 border-l-2 border-[#ffcc00] bg-[#ffcc00]/[0.04] text-[10px] font-mono-data uppercase tracking-wider text-[#ffcc00]"
    >
      <Warning size={12} weight="fill" className="mt-0.5 shrink-0"/>
      <span className="leading-relaxed">{cfg.text}</span>
    </div>
  );
}
